export const capitalizeFirstLetter = (string?: string) => {
  if (!string) return ""
  string = string.replace("&#8211;", "-");
  return string.charAt(0).toUpperCase() + string.slice(1)
}
